/* istanbul ignore file */
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { spacing } = themeVariables;

export const wrapper = css`
  margin: 0 0 var(${spacing.xxxl}) 0;
`;
